import './App.css';
import { initializeIcons } from '@fluentui/react';
import { Login } from './components/Login/Login';
import UserDetail from './components/UserDetail/UserDetail';
import { EmployeeProvider } from './components/Contexts/EmployeeContext';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ProgressUpdates from './components/ProgressUpdates/ProgressUpdates';
import { SubjectProvider } from './components/Contexts/SubjectContext';
import EvaluationForm from './components/EvaluationForm/EvaluationForm';
import Layout from './components/Layout/Layout';
import AdminRoute from './components/AdminRoute/AdminRoute';
import Dashboard from './components/Dashboard/Dashboard';
import AdminView from './components/AdminView/AdminView';

initializeIcons();

const App = () => {
  return (
    <div className="App">
      <SubjectProvider>
        <EmployeeProvider>
          <BrowserRouter basename="/hubProfesores">
            <Layout />
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/horario"
                element={
                  <ProtectedRoute>
                    <UserDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload-file/:subjectCode"
                element={
                  <ProtectedRoute>
                    <ProgressUpdates />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload-evaluation-form/:subjectCode"
                element={
                  <ProtectedRoute>
                    <EvaluationForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <AdminRoute>
                    <Dashboard />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminView />
                  </AdminRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </EmployeeProvider>
      </SubjectProvider>
    </div>
  );
};

export default App;
